import { lazy } from 'react';
import { createRouteItem } from 'utils/navigation';
import HomeContainer from './Home';
import ClientsContainer from './Clients';
import Operation from './Operation';
// import ModelPortfolioRoute from './ModelPortfolio';
import ConfiguracionContainer from './Configuration';
import ComplianceContainer from './Compliance';

const ModelPortfolioRoute = lazy(() => import('./ModelPortfolio'));
const FoundsContainer = lazy(() => import('./Founds'));
const RebalanceFundsContainer = lazy(() => import('./RebalanceFunds'));

const routes = [
  {
    path: '/',
    exact: true,
    component: HomeContainer,
    breadcrumbs: {
      title: 'Bienvenido',
      routes: [createRouteItem('Home', '/')],
    },
  },
  {
    path: '/clientes',
    component: ClientsContainer,
    breadcrumbs: {
      title: 'Administrar Clientes',
      routes: [createRouteItem('Clientes', '/clientes')],
    },
  },
  {
    path: '/fondos',
    component: FoundsContainer,
    breadcrumbs: {
      title: 'Administrar Fondos',
      routes: [createRouteItem('Fondos', '/fondos')],
    },
  },
  {
    path: '/configuracion',
    component: ConfiguracionContainer,
    breadcrumbs: {
      title: 'Configuracion',
      routes: [createRouteItem('Configuracion', '/configuracion')],
    },
  },
  {
    path: '/archivos',
    component: Operation,
    breadcrumbs: {
      title: 'Operación',
      routes: [createRouteItem('Archivos', '/archivos')],
    },
  },
  {
    path: '/portafolio-modelo',
    component: ModelPortfolioRoute,
  },
  {
    path: '/portafolio-fondos/',
    component: RebalanceFundsContainer,
  },
  {
    path: '/cumplimiento',
    component: ComplianceContainer,
    breadcrumbs: {
      title: 'Cumplimiento',
      routes: [createRouteItem('Cumplimiento', '/cumplimiento')],
    },
  },
];

export default routes;
